<div class="d-flex flex-column w-100">
  <div>
    <div class="d-flex flex-row justify-content-around flex-wrap">
      <div class="card-size am-card m-3" *ngFor="let flag of languages " (click)="onSelectLanguage(flag)"
      >
        <div class="flag flag-property" [ngClass]="{
          'flag-mexico': flag.id === 'es-MX',
          'flag-usa': flag.id === 'en-US',
          'flag-france': flag.id === 'fr-FR',
          'flag-holland': flag.id === 'du-NL',
          'flag-portuguese': flag.id === 'pt-PT',
          'flag-japanese': flag.id === 'ja-JP',
          'flag-chinese': flag.id === 'zh-CN',
          'flag-korean': flag.id === 'kr-KR'
          }">

        </div>
        <div class="text-center title-language">
          {{ flag.text }}
        </div>
      </div>
    </div>
  </div>
</div>
